// extracted by mini-css-extract-plugin
module.exports = {"Component":"Breadcrumb_Component__1Befr","Wrapper":"Breadcrumb_Wrapper__3ZPpY","Title":"Breadcrumb_Title__2o9Oz"};